import { render, staticRenderFns } from "./CotacoesMarketplaceList.vue?vue&type=template&id=089d171e"
import script from "./CotacoesMarketplaceList.vue?vue&type=script&lang=js"
export * from "./CotacoesMarketplaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports